import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppButton from "../../components/app-button/AppButton";
import AppTable from "../../components/app-table/AppTable";
import Iconify from "../../components/iconify/Iconify";
import { getCustomers } from "../../reduxStore/slices/customerSlice";
import { useNotify } from "../../utils/snackbarUtils";
import CustomerDialog from "./CustomerDialog";

function Customers(props) {
  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { list: tableRows, loading: isLoading } = useSelector(
    (state) => state.customer
  );
  const storeId = user?.storeId;
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const tableHead = [
    { id: "name", label: "Name", align: "left" },
    { id: "mobileNo", label: "Mobile No.", align: "left" },
    { id: "email", label: "Email", align: "left" },
    { id: "city", label: "City", align: "left" },
    { id: "createdAt", label: "Created At", align: "left" },
    { id: "actions", label: "Actions", align: "center", width: "120px" },
  ];

  const handleDialogCancel = () => {
    setIsAddDialogOpen(false);
    setSelectedRow({});
  };

  const handleAddCustomer = () => {
    setIsAddDialogOpen(true);
  };

  const editActionClick = (event, row) => {
    setSelectedRow(row);
    handleAddCustomer();
  };
  const viewActionClick = () => {
    navigate("/app/customers/view/1");
  };

  const getAllCustomers = async () => {
    try {
      await dispatch(getCustomers({ storeId })).unwrap();
    } catch (err) {
      handleApiError(err);
    }
  };

  useEffect(() => {
    if (storeId) {
      getAllCustomers();
    }
  }, [storeId]);

  return (
    <Box
      sx={{
        margin: "25px 60px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <Typography variant="h5" gutterBottom>
          Customers
        </Typography>
        <AppButton
          onClick={handleAddCustomer}
          variant="contained"
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          New Customer
        </AppButton>
      </Stack>
      <Box>
        <AppTable
          tableHead={tableHead}
          tableRows={tableRows}
          listType="customerTables"
          searchPlaceholder="Search By Mobile No."
          editActionClick={editActionClick}
          viewActionClick={viewActionClick}
          searchField={"mobile_no"}
        />
      </Box>

      {isAddDialogOpen && (
        <CustomerDialog
          onDialogCancel={handleDialogCancel}
          isDialogOpen={isAddDialogOpen}
          customerData={selectedRow}
        />
      )}
    </Box>
  );
}

export default Customers;
